// @ts-nocheck
// disable checking because of react router typings issues
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import routes, { IRoute } from './routes';

import { AuthRoute } from 'auth.route';
import { useStore } from 'app/context';
import BusyScreen from 'app/components/BusyScreen';
import 'moment/locale/de';
import moment from 'moment';
import NotFoundContainer from 'app/containers/NotFoundContainer';
import { QueryParamProvider } from 'use-query-params';
import * as Sentry from '@sentry/react';
import { PdfViewer } from 'app/components/PdfViewer';
moment.locale('de');

const appClass = () => {
	const s = window.localStorage.getItem('debug');
	return s !== 'true' ? 'application' : 'application allow-debug';
};

const NotFound: React.FC = observer(() => {
	return <NotFoundContainer />;
});

const HistoryTracer = () => {
	const { userSettingsStore } = useStore();
	const history = useHistory();

	const setSentryRoute = (pathname: string, search: string) => {
		const route = pathname + search;
		Sentry.setTag('route', route);
		Sentry.setContext('route', {
			pathname,
			search,
			hash: window.location.hash,
			fullPath: `#${route}`,
		});
	};

	useEffect(() => {
		let lastTrackedPath = history.location.pathname;
		setSentryRoute(history.location.pathname, history.location.search);
		userSettingsStore.trackNav(history.location.pathname, history.location.search);
		const unlisten = history.listen((location, action) => {
			console.log('[Navigation]', action, location.pathname + location.search);
			setSentryRoute(location.pathname, location.search);
			userSettingsStore.addHistoryItem(location.pathname, location.search);
			if (location.pathname !== lastTrackedPath) {
				lastTrackedPath = location.pathname;
				userSettingsStore.trackNav(location.pathname, location.search);
			}
		});
		return unlisten;
	}, [history, userSettingsStore]);

	return <></>;
};

if (process.env.REACT_APP_ENV === 'production') {
	Sentry.init({
		dsn: 'https://586c6bdd912c40bca88f3e272d87ac50@o287519.ingest.sentry.io/5890677',
		integrations: [new Sentry.BrowserTracing({})],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
	});
}

const App: React.FC = observer((props) => {
	const { authStore, session } = useStore();
	const [isSetup, setIsSetup] = useState(false);

	useEffect(() => {
		authStore.setup().then(() => {
			setIsSetup(true);
		});
	}, [authStore]);

	if (process.env.REACT_APP_ENV !== 'production') {
		document.title = process.env.REACT_APP_ENV?.toUpperCase() || 'DVS DEV';
	}

	if (process.env.REACT_APP_ENV === 'production') {
		document.title = 'DVS';
	}

	return (
		<div className={appClass()}>
			{authStore.settingUp && <>Loading...</>}
			{session.isApiBusy && <BusyScreen />}
			{isSetup && (
				<Router>
					<QueryParamProvider ReactRouterRoute={Route}>
						<Switch>
							{Object.keys(routes).map((key, i) => {
								const r = (routes as any)[key] as IRoute;
								if (r.private) {
									return <AuthRoute key={key} exact={r.exact ? r.exact! : true} component={r.container} path={r.route} />;
								}
								return <Route key={key} exact={r.exact ? r.exact : true} component={r.container} path={r.route} />;
							})}
							<Route component={NotFound} />
						</Switch>
						<HistoryTracer />
					</QueryParamProvider>
				</Router>
			)}
			{!session.isApiBusy && <small className="print-page-loaded">.</small>}
			<PdfViewer />
		</div>
	);
});

export default App;
